module.exports = __webpack_public_path__ + "img/DynamoDB-Partitions-Formula.909c3419.png";